export default "__VITE_ASSET__D6uIrC8S__"